/**
 * Componente de protección de rutas
 * Redirige a login si el usuario no está autenticado
 */

import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores';
import { Spinner } from '../ui';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
    const location = useLocation();
    const { user, isInitialized, isLoading } = useAuthStore();

    // Mostrar loading mientras se verifica la sesión
    if (!isInitialized || isLoading) {
        return (
            <div className="route-loading">
                <Spinner size="large" />
            </div>
        );
    }

    // Redirigir a login si no hay usuario
    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Sprint 8: Permitir que admins accedan a rutas protegidas normales (ej: /settings)
    // La redirección específica de admins se maneja en rutas individuales si es necesario
    return <>{children}</>;
}

/**
 * Componente para rutas de invitados (login/register)
 * Redirige a home si el usuario ya está autenticado
 */
interface GuestRouteProps {
    children: React.ReactNode;
}

export function GuestRoute({ children }: GuestRouteProps) {
    const { user, isInitialized, loginDeviceState } = useAuthStore();

    // Mostrar loading mientras se verifica la sesión
    if (!isInitialized) {
        return (
            <div className="route-loading">
                <Spinner size="large" />
            </div>
        );
    }

    // Durante post-login en /login, permitir que LoginPage complete
    // el flujo biométrico antes de redirigir fuera de la ruta invitada.
    if (user && loginDeviceState !== 'success') {
        return <Navigate to={user.is_admin ? '/admin' : '/'} replace />;
    }

    return <>{children}</>;
}
